import Vue from 'vue';
Vue.filter('time', function (val, type) {
    if (!val)return '';
    let a = '';
    a += val.getHours() > 9 ? '' : '0';
    a += val.getHours();
    a += ':';
    a += val.getMinutes() > 9 ? '' : '0';
    a += val.getMinutes();
    return a;
});